<template>
  <div>
    <input type="file" @change="handleChange" />
    <div><input type="button" @click="handleClose" value="关闭窗口" /></div>
    <div><input type="button" @click="handleReplace" value="发送数据" /></div>
  </div>
</template>

<script>
export default {
  mounted() {
    window.addEventListener('message', this.receiveMessage, false)
  },
  methods: {
    // 子页面自定义关闭
    handleClose() {
      window.parent.postMessage({ type: 'close' }, '*')
    },
    // 子页面自定义更改二维表数据
    handleReplace() {
      console.log('times, 11')
      window.parent.postMessage({
        type: 'replace',
        data: [{ jisu1: '1', jisuan1: '2', upperCase: '壹', zbjsq: '2' }, { jisu1: '3', jisuan1: '33', upperCase: 'aksjdfl', zbjsq: '2' }]
      }, '*')

      // const a = { XM: '', PFHZ: '3.88', BZ: '一条记录', id: '' }
      // setTimeout(() => {
      //   const {
      //     HZDF,
      //     BZ,
      //     name,
      //     id
      //   } =
      //   that.viewFormData.modelData
      //   window.parent.postMessage({
      //     type: 'replace',
      //     data: [{ XM: name[0].name, PFHZ: HZDF, BZ, id }]
      //   }, '*')
      // }, 1500)
      // window.parent.postMessage({
      //   type: 'replace',
      //   data: [{ XM: '', PFHZ: '3.88', BZ: '一条记录', id: '' }]
      // }, '*')
    },

    // 不同表单复用添加数据
    // const save2 = async() => {
    //   await that.handleSave({}, item)
    //   if (that.viewFormData?.modelData?.id) {
    //     window.parent.postMessage({
    //       type: 'replace',
    //       data: [that.viewFormData.modelData]
    //     }, '*')
    //   }
    // }

    // 平台按钮确定更改二维表数据
    handleChange(e) {
      // example, please modify !!
      let fd = new FormData()
      fd.append('file', e.target.files[0])
      this.$http.post('/common/document/upload', fd, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        this.$message.success('文件上传成功!')
        // Todo 二开： 处理上传成功后逻辑
        console.log(res)
        const data = [{ jisu1: '1', jisuan1: '2', upperCase: '壹', zbjsq: '2' }] // mock，请用处理后的数据替换
        // 调用回写二维表数据方法，参数为数组json对象
        parent.window.iframeCallBack(data)
      }).catch((error) => {
        this.$message.error(error.msg)
      })
    }
  }
}
</script>
